import React, {Component } from 'react';
import {Button, Input, InputGroup, InputGroupAddon} from 'reactstrap'
import "../../Chat.scss";

export default class ChatInput extends Component {
    constructor(props){
        super(props)
        this.sendMessage = this.sendMessage.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.state = {
            text: null
        }
    }

    sendMessage(){
        if(this.state.text && this.state.text.length > 0){
            this.props.sendMessage(this.state.text)
            this.resetInput();
        }
    }

    handleInputChange(event){
       this.setState({text: event.target.value})
    }

    handleKeyPress(event){
        if(event.key === 'Enter'){
            this.sendMessage();
        }
    }

    resetInput(){
        this.setState({
            text: null
        });

        this.textInput.value = ""
    }

    render(){
        return (
          <></>
            // <InputGroup className="conv-id-input-group">
            //     <Input
            //         innerRef={(textInput) => { this.textInput = textInput }}
            //         onChange={this.handleInputChange}
            //         onKeyPress={this.handleKeyPress}
            //         onFocus={this.props.startConversation}
            //         type={this.props.redactInput ? "password" : ""}
            //         placeholder={this.props.conversationStarted ? null : "Click here to begin chat"} />
            //     <InputGroupAddon addonType="append">
            //         <Button onClick={this.sendMessage} color="primary">
            //             <i className="icon-paper-plane icons font-lg icon-paper-plane-color"></i>
            //         </Button>
            //     </InputGroupAddon>
            // </InputGroup>
        )
    }
}

